import Axios from "axios";

export const verifyEmailOtp = async (tempToken, otp) => {
  const res = await Axios({
    method: "POST",
    url: `${process.env.REACT_APP_BASE_URL}/email-otp/verify`,
    headers: { "Content-Type": "application/json" },
    data: { tempToken, otp },
  });
  return res;
};

export const resendEmailOtp = async (tempToken) => {
  const res = await Axios({
    method: "POST",
    url: `${process.env.REACT_APP_BASE_URL}/email-otp/send`,
    headers: { "Content-Type": "application/json" },
    data: { tempToken },
  });
  return res;
};

export const verifyTotpLogin = async (tempToken, token) => {
  const res = await Axios({
    method: "POST",
    url: `${process.env.REACT_APP_BASE_URL}/mfa/verify`,
    headers: { "Content-Type": "application/json" },
    data: { tempToken, token, isAdmin: false },
  });
  return res;
};
